import {combineReducers} from '@reduxjs/toolkit';

import autoResultsSlice from 'App/features/autoResults/autoResultsSlice';
import featureFlags from 'App/features/featureFlags/featureFlagsSlice';
import map2DEntities from 'App/features/map2DEntities/map2DEntitiesReducer';
import map3DEntities from 'App/features/map3DEntities/map3DEntitiesReducer';
import search from 'App/features/search/searchSlice';
import searchEntities from 'App/features/searchEntities/searchEntitiesReducer';
import user from 'App/features/user/userSlice';
import layout from 'App/layout/layoutSlice';

const rootReducer = combineReducers({
  layout,
  user,
  featureFlags,
  search,
  searchEntities,
  map3DEntities,
  map2DEntities,
  autoResults: autoResultsSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
